import { render, staticRenderFns } from "./SwitchTag.vue?vue&type=template&id=d96751d4&scoped=true"
import script from "./SwitchTag.vue?vue&type=script&lang=js"
export * from "./SwitchTag.vue?vue&type=script&lang=js"
import style0 from "./SwitchTag.vue?vue&type=style&index=0&id=d96751d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96751d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
